class SizeGuide extends HTMLElement {
  constructor() {
    super();
    this.switchers = this.querySelectorAll('.size-guide__content-switcher span');
    this.size_guide_rows = this.querySelectorAll('.size-guide-row');
    this.size_guide_container = this.querySelector('.size-guide__container');
    this.size_guide_link = this.querySelector('.size-guide__link');
    this.size_buide_close = this.querySelector('.size-guide__content-close');
    this.swipe_close = this.querySelector('.size_guide__content-mobile-scroller');
    this.attachEvents();
    this._setSwipeOffset(0);
  }

  _setSwipeOffset(px) {
    this.style.setProperty('--swipe-offset', `${px}px`);
  }
  attachEvents() {
    var that = this;
    this.size_guide_link.addEventListener('click', function(e){
      that.size_guide_container.classList.add('active');
      document.body.style.overflow = 'hidden';
      document.querySelector('html').style.overflow = 'hidden';
      that._isOpen = true;
    })
    if(this.switchers.length > 0){
      this.switchers.forEach((switch_but)=>{
        switch_but.addEventListener('click', function(){
          that.switchers.forEach((el)=>{
            el.classList.remove('active');
          })
          switch_but.classList.add('active');
          var switch_data_but = switch_but.getAttribute('data-but');
          if(that.size_guide_rows.length > 0) {
            that.size_guide_rows.forEach((row) => {
              row.style.display = 'none';
            });
          }
          if(that.querySelectorAll('.size-guide-row.'+switch_data_but).length > 0) {
            that.querySelectorAll('.size-guide-row.'+switch_data_but).forEach((row) => {
              row.style.display = 'flex';
            });
          }

        })
      })
    }
    this.querySelector('.size-guide__content-wrap').addEventListener('click', function(e){
      e.stopPropagation();
    })
    this.size_guide_container.addEventListener('click', function(e){
      this.classList.remove('active');
      document.body.style.overflow = 'initial';
      document.querySelector('html').style.overflow = 'initial';
    })
    this.size_buide_close.addEventListener('click', function(e){
      that.size_guide_container.classList.remove('active');
      document.body.style.overflow = 'initial';
      document.querySelector('html').style.overflow = 'initial';
    })


    this.swipe_close.addEventListener('touchstart', e => {
      this.touchstart = e.targetTouches[0].clientY;
      this.touchend = null;
    });

    this.swipe_close.addEventListener('touchmove', (e) => {
      this.touchend = e.targetTouches[0].clientY;
      this._setSwipeOffset(Math.max(0, this.touchend - this.touchstart));
    });

    this.swipe_close.addEventListener('touchend', () => {
      if (this.touchend && this.touchend - this.touchstart > 50) {
        if (!that._isOpen) return;
        document.body.style.overflow = 'initial';
        document.querySelector('html').style.overflow = 'initial';
        that.size_guide_container.classList.remove('active');
      }
      this._setSwipeOffset(0);
    });
  }
}

customElements.define('size-guide', SizeGuide);
